module.exports = __webpack_public_path__ + "img/logo-psd2.2d2b99de.webp";